"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageDeliveryStatus = exports.MessageType = exports.ConversationScope = exports.ConversationContextType = void 0;
var ConversationContextType;
(function (ConversationContextType) {
    ConversationContextType["SERVICE_REQUEST"] = "service_request";
    ConversationContextType["TREATMENT_PLAN"] = "treatment_plan";
    ConversationContextType["BOOKING"] = "booking";
    ConversationContextType["SUPPORT"] = "support";
    ConversationContextType["QUOTE"] = "quote";
})(ConversationContextType || (exports.ConversationContextType = ConversationContextType = {}));
var ConversationScope;
(function (ConversationScope) {
    ConversationScope["PATIENT_DOCTOR"] = "patient_doctor";
    ConversationScope["PATIENT_ADMIN"] = "patient_admin";
    ConversationScope["DOCTOR_ADMIN"] = "doctor_admin";
    ConversationScope["INTERNAL"] = "internal";
})(ConversationScope || (exports.ConversationScope = ConversationScope = {}));
var MessageType;
(function (MessageType) {
    MessageType["TEXT"] = "text";
    MessageType["SYSTEM"] = "system";
    MessageType["FILE"] = "file";
})(MessageType || (exports.MessageType = MessageType = {}));
var MessageDeliveryStatus;
(function (MessageDeliveryStatus) {
    MessageDeliveryStatus["SENT"] = "sent";
    MessageDeliveryStatus["DELIVERED"] = "delivered";
    MessageDeliveryStatus["READ"] = "read";
})(MessageDeliveryStatus || (exports.MessageDeliveryStatus = MessageDeliveryStatus = {}));
//# sourceMappingURL=messaging.types.js.map